function getDataIconAttribute(chroma?: string, icon?: string, size?: string) {
  if (chroma === 'default') {
    return `${icon}-${size}-default`;
  }

  if (chroma === 'dark') {
    return `${icon}-${size}-solid`;
  }

  return `${icon}-${size}`;
}

export default getDataIconAttribute;
